import { useReducer, useMemo } from 'react';
import reducer from '../reducers';
import { init } from '../config';

function useControlState(defaultsControls) {
  const [chartControls, dispatch] = useReducer(reducer, defaultsControls, init);

  const controlState = useMemo(() => {
    const {
      chartMetrics: { primaryMetric, secondaryMetric },
      chartSettings: { appearance = [], metricView },
    } = chartControls;

    const stacked = appearance.includes('stacked');
    const verticalGridlines = appearance.includes('verticalGridlines');
    const horizontalGridlines = appearance.includes('horizontalGridlines');
    const highlightWeekends = appearance.includes('highlightWeekends');
    const percentage = metricView;

    return ({
      ...chartControls,
      stacked,
      verticalGridlines,
      horizontalGridlines,
      highlightWeekends,
      percentage,
      primaryMetricName: primaryMetric.metric,
      primaryChartType: primaryMetric.chartType,
      secondaryMetricName: secondaryMetric.metric,
      secondaryChartType: secondaryMetric.chartType,
    });
  }, [chartControls]);

  return [controlState, dispatch];
}

export default useControlState;
